// Convert game tick to in-game date
export function tickToGameDate(tick: number): { month: string; day: number; year: number } {
  // Each Utopia year has 7 months, each month has ~24 ticks (days)
  // Total ticks per year: 7 * 24 = 168
  const TICKS_PER_MONTH = 24;
  const MONTHS_PER_YEAR = 7;
  const TICKS_PER_YEAR = TICKS_PER_MONTH * MONTHS_PER_YEAR;

  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  const year = Math.floor(tick / TICKS_PER_YEAR);
  const tickInYear = tick % TICKS_PER_YEAR;
  const monthIndex = Math.floor(tickInYear / TICKS_PER_MONTH);
  const day = (tickInYear % TICKS_PER_MONTH) + 1;

  return {
    month: MONTHS[monthIndex] || 'January',
    day,
    year,
  };
}

// Format day with ordinal suffix
export function formatDay(day: number): string {
  const suffix = ['th', 'st', 'nd', 'rd'];
  const v = day % 100;
  return day + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
}

// Format an absolute in-game tick as a fixed date string, e.g. "March 3rd, YR2" — matches
// AttackResult.tsx's existing inline formatting verbatim (SF-158). Use for past-event timestamps
// (war started/declared); not a countdown — pair those with formatDuration() instead.
export function formatGameDate(tick: number): string {
  const date = tickToGameDate(tick);
  return `${date.month} ${formatDay(date.day)}, YR${date.year}`;
}

// Format current real time
export function formatClockTime(): string {
  const now = new Date();
  return now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}
